import { render, staticRenderFns } from "./FinancialDetail.vue?vue&type=template&id=c03328ec&scoped=true&"
import script from "./FinancialDetail.vue?vue&type=script&lang=js&"
export * from "./FinancialDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03328ec",
  null
  
)

export default component.exports